export type QueryParameters = Record<string, string>;

export const buildQueryParameterUrl = (queryParams: QueryParameters): string =>
  Object.keys(queryParams)
    .map((key) => [key, queryParams[key]].join('='))
    .join('&')
    .replace(' ', '%20');

export const getQueryParameterByName = (
  name: string,
  search: string,
): string | undefined =>
  search
    .substring(search.indexOf(`${name}=`))
    .split('&')[0]
    .split('=')[1];
